<template>
  <div id="about" class="about-wrap style4 pt-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="about-img-wrap">
            <img src="../../assets/images/about/about-img-6.jpg" alt="Image" />
          </div>
        </div>

        <div class="col-lg-6">
          <div class="about-content">
            <div class="content-title style4">
              <span>About Us</span>
              <h2>
                We Provide Special Care Through Our Certified &amp; Experience
                Doctors
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using amet has.
              </p>
            </div>
            <ul class="nav nav-tabs about-tablist" role="tablist">
              <li class="nav-item">
                <button
                  class="tab-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_10"
                  type="button"
                  role="tab"
                >
                  Specialist Doctors
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_20"
                  type="button"
                  role="tab"
                >
                  Orthopedic Solutions
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_30"
                  type="button"
                  role="tab"
                >
                  Special Treatment
                </button>
              </li>
            </ul>
            <div class="tab-content about-tab-content">
              <div
                class="tab-pane fade show active"
                id="tab_10"
                role="tabpanel"
              >
                <div class="row gx-4 align-items-center">
                  <div class="col-md-6">
                    <div class="about-img">
                      <img
                        src="../../assets/images/about/about-img-7.jpg"
                        alt="Image"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <h5>It's A Hospital Healthcare Solution</h5>
                    <ul class="content-feature-list list-style style4">
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Stop worrying, we will take care of your physical
                        problems
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Challenges with dental insurance can take valuable time
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Dental insurance issues are the most important that
                        dentists face
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="tab_20" role="tabpanel">
                <div class="row gx-4 align-items-center">
                  <div class="col-md-6">
                    <div class="about-img">
                      <img
                        src="../../assets/images/about/about-img-8.jpg"
                        alt="Image"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <h5>It's A Hospital Healthcare Solution</h5>
                    <ul class="content-feature-list list-style style4">
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Dental insurance issues are the most important that
                        dentists face
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Challenges with dental insurance can take valuable time
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Stop worrying, we will take care of your physical
                        problems
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="tab_30" role="tabpanel">
                <div class="row gx-4 align-items-center">
                  <div class="col-md-6">
                    <div class="about-img">
                      <img
                        src="../../assets/images/about/about-img-10.jpg"
                        alt="Image"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <h5>Special Treatment For Adult</h5>
                    <ul class="content-feature-list list-style style4">
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Challenges with dental insurance can take valuable time
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Stop worrying, we will take care of your physical
                        problems
                      </li>
                      <li>
                        <span><i class="ri-check-double-line"></i></span>
                        Dental insurance issues are the most important that
                        dentists face
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>